import { render } from "./PpcStrategies.vue?vue&type=template&id=2443dc63&scoped=true"
import script from "./PpcStrategies.vue?vue&type=script&lang=js"
export * from "./PpcStrategies.vue?vue&type=script&lang=js"

import "./PpcStrategies.vue?vue&type=style&index=0&id=2443dc63&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2443dc63"]])

export default __exports__